<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    dialog-width="80%"
    :title="dataTree.name"
    :has-agree="false"
    header-shadow
    min-body-height="500px"
  >
    <template #body>
      <data-tree
        :data-tree="dataTree"
        :data-tree-result="dataTreeResult"
        :loading="loading"
        :headers="headers"
        disable-zoom
      />
    </template>
  </main-large-dialog>
</template>
<script>
import { get } from 'vuex-pathify';

import DataTree from '@/components/DataTree';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'DataTreeDialog',
  components: { DataTree, MainLargeDialog },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    dataTree: {
      type: Object,
      required: true,
    },
    dataTreeResult: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataTreeAdditionalCols: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    headers() {
      return [
        { key: 'name', translationPath: 'sidebar.dataTree.name' },
        {
          key: 'area',
          translationStraight: `${this.$i18n.t('sidebar.dataTree.area')} [ha]`,
          valueFormater: value => {
            return (value / 10000).toFixed(4);
          },
        },
        { key: 'count', translationPath: 'sidebar.dataTree.count' },
        ...this.dataTreeAdditionalCols.map(col => {
          return { key: col, translationStraight: col };
        }),
      ];
    },
  },
};
</script>
